export const infinityCards = [
  {
    id: "08ahgmfrUXkqjuZrw5YW",
    max: "7",
    finite: "FALSE",
    bgColor1: "#be4dd8",
    turnsActive: "Instant",
    effect: "Increases Defense by 2",
    availForPurchase: false,
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FFortify%20Elixir.png?alt=media&token=e8ff379c-a78b-453e-b285-113feb0f06df",
    price: "",
    description: "A glowing elixir known for its defensive enhancements.",
    bgColor2: "#2b1b53",
    craftAmount: "null",
    name: "Fortify Elixir",
    areaAffected: ["Defense"],
    season: "1",
    craftNeeded: "null",
  },
  {
    id: "0aiT3rnQa3F10DxiT7JP",
    name: "Shock Mine",
    finite: "FALSE",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FShock%20Mine.png?alt=media&token=cb11dc6b-dd7c-4053-a1c2-cd85b614d6e2",
    bgColor1: "#ffffff",
    bgColor2: "#adfaff",
    areaAffected: ["Turn Loss"],
    season: "1",
    price: "",
    effect: "Target loses 1 turn",
    description: "A planted energy mine that stuns on activation.",
    craftAmount: "null",
    max: "7",
    craftNeeded: "null",
    availForPurchase: false,
    turnsActive: "Instant",
  },
  {
    id: "1t9ruhC7mRj5vVhqyzjO",
    craftAmount: "null",
    description: "A concentrated essence of life extracted from rare blooms.",
    effect: "Restores 1 health per turn for 3 turns (total 3 health).",
    name: "Vitality Vial",
    craftNeeded: "null",
    max: "3",
    bgColor1: "#d52114",
    price: "",
    bgColor2: "#ffffff",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FVitality%20Vial.png?alt=media&token=4131a6b5-d134-47fd-927d-82d923134710",
    finite: "FALSE",
    turnsActive: "3 turns",
    areaAffected: ["Health"],
    availForPurchase: false,
    season: "1",
  },
  {
    id: "2k9gx7RiWNpYh7XQ8VbP",
    name: "Superior Renewal Nectar",
    price: "",
    description:
      "A refined nectar with maximized restorative properties, created by merging Renewal Nectar doses.",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FSuperior%20Renewal%20Nectar.png?alt=media&token=db74b94b-d15d-4b4e-bd6a-85c8761b64f7",
    craftNeeded: "Renewal Nectar",
    season: "1",
    areaAffected: ["Health"],
    effect: "Restores 3 health over 2 turns.",
    finite: "TRUE",
    turnsActive: "2 turns",
    max: "2",
    availForPurchase: false,
    craftAmount: "3",
    bgColor2: "#f042ba",
    bgColor1: "#febcf9",
  },
  {
    id: "3TW3qkAKIOrhY2iGsCRq",
    availForPurchase: false,
    price: "",
    description: "A pulsating potion sending waves of healing energy.",
    areaAffected: ["Health"],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FPulse%20of%20Life.png?alt=media&token=9b601366-00f2-49e6-a66d-92079cc09989",
    effect:
      "Restores 1 health instantly and an additional 1 health after 1 turn (total 2 health).",
    bgColor1: "#b2e26a",
    bgColor2: "#1b9533",
    craftAmount: "null",
    finite: "FALSE",
    craftNeeded: "null",
    season: "1",
    turnsActive: "2 turns",
    max: "7",
    name: "Pulse of Life",
  },
  {
    id: "4XYtsS8XCnoMDWGZO1dL",
    description:
      "A tonic crafted from rare leaves that gently restores vitality.",
    bgColor1: "#017ee7",
    finite: "FALSE",
    max: "4",
    availForPurchase: false,
    craftNeeded: "null",
    effect: "Restores 1 health per turn for 3 turns (total 3 health).",
    name: "Herbal Tonic",
    bgColor2: "#ffffff",
    price: "",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FHerbal%20Tonic.png?alt=media&token=5bfb58bd-9aa8-45bd-9a8f-0af2bf5115e8",
    season: "1",
    turnsActive: "3 turns",
    craftAmount: "null",
    areaAffected: ["Health"],
  },
  {
    id: "4igatDDkNcM2FN5N4iBM",
    areaAffected: ["Accuracy"],
    finite: "FALSE",
    name: "Falcon’s Feather Band",
    price: "",
    description:
      "A headband made from the plume of a sky beast, enhancing aerial judgment.",
    bgColor2: "#9a4f10",
    max: "7",
    bgColor1: "#ffffff",
    availForPurchase: false,
    craftAmount: "null",
    turnsActive: "Instant",
    season: "1",
    craftNeeded: "null",
    effect: "Increases Accuracy by 2",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FFalcon%E2%80%99s%20Feather%20Band.png?alt=media&token=0311d425-b499-4898-b7f3-47ec6928cc97",
  },
  {
    id: "5JscJ4h77cB2P2weFpDx",
    bgColor1: "#f799fb",
    season: "1",
    availForPurchase: false,
    description:
      "A ghostly shard from lost spectral armor that wards off impact.",
    turnsActive: "Instant",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FPhantom%20Plate%20Fragment.png?alt=media&token=5ab0bfbd-0259-46d1-bfad-a7f3634cd192",
    craftAmount: "null",
    name: "Phantom Plate Fragment",
    effect: "Increases Defense by 3",
    craftNeeded: "null",
    bgColor2: "#d752e4",
    max: "3",
    price: "",
    finite: "FALSE",
    areaAffected: ["Defense"],
  },
  {
    id: "7vRbuUKs3Zxuux2QrB2E",
    bgColor1: "#d9fdff",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FSleep%20Mist.png?alt=media&token=8ded281b-5588-4120-a6b5-2f80cb609f1e",
    description:
      "A soft cloud of enchanted vapor that causes sudden drowsiness.",
    max: "7",
    name: "Sleep Mist",
    effect: "Target loses 1 turn",
    bgColor2: "#9dfaff",
    season: "1",
    areaAffected: ["Turn Loss"],
    price: "",
    craftAmount: "null",
    availForPurchase: false,
    craftNeeded: "null",
    finite: "FALSE",
    turnsActive: "Instant",
  },
  {
    id: "80d0ESY0zh8IMIXLrXuq",
    craftNeeded: "Obsidian Bracers",
    season: "1",
    effect: "Increases Defense by 4",
    craftAmount: "3",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FFortified%20Obsidian%20Core.png?alt=media&token=62ae04bd-3f0b-4399-8f1e-7028e009790e",
    description:
      "Refined from multiple Obsidian Bracers, this gem pulses with power.",
    max: "2",
    finite: "TRUE",
    areaAffected: ["Defense"],
    bgColor1: "#f82110",
    bgColor2: "#000000",
    price: "",
    turnsActive: "Instant",
    availForPurchase: false,
    name: "Fortified Obsidian Core",
  },
  {
    id: "A0yMlD4g0JPmHCIeqeb5",
    max: "3",
    bgColor2: "#fedc5f",
    season: "1",
    name: "Serenity Serum",
    craftAmount: "null",
    effect: "Restores 2 health per turn for 3 turns (total 6 health).",
    finite: "FALSE",
    craftNeeded: "null",
    turnsActive: "3 turns",
    bgColor1: "#cb6d19",
    price: "",
    areaAffected: ["Health"],
    description: "A calming serum that heals wounds while soothing the spirit.",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FSerenity%20Serum.png?alt=media&token=dbc6157a-02f7-418d-8b5a-6f5f88e7cc61",
    availForPurchase: false,
  },
  {
    id: "A20fhVDjJuGZoqxVRaYt",
    price: "",
    availForPurchase: false,
    bgColor1: "#ffffff",
    finite: "TRUE",
    season: "1",
    craftNeeded: "Trickshot Tonic",
    bgColor2: "#fcc832",
    name: "Trickshot Flask Supreme",
    areaAffected: ["Accuracy"],
    effect: "Increases Accuracy by 5",
    max: "1",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FTrickshot%20Flask%20Supreme.png?alt=media&token=957da427-bfcf-4782-8d7b-8af3a81df580",
    turnsActive: "Instant",
    description:
      "A potent version of the Trickshot Tonic, used in elite duels.",
    craftAmount: "3",
  },
  {
    id: "BBbu2DLPQJCC0U4WrTm8",
    areaAffected: ["Attack"],
    craftAmount: "null",
    max: "7",
    craftNeeded: "null",
    price: "",
    availForPurchase: false,
    bgColor2: "#fd4e15",
    bgColor1: "#fc4815",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FWarhorn%20Brew.png?alt=media&token=c8ba266c-72fb-40c2-b09e-976ff5e782ea",
    finite: "FALSE",
    description: "A spiced drink that stirs the rage of battle.",
    name: "Warhorn Brew",
    turnsActive: "Instant",
    effect: "Increases Attack by 2",
    season: "1",
  },
  {
    id: "BItmGNgIv4o969Jkd9sR",
    bgColor1: "#c4c4c4",
    name: "Obsidian Bracers",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FObsidian%20Bracers.png?alt=media&token=f01484ed-9585-48bc-882e-94a33d8c8d42",
    availForPurchase: false,
    craftNeeded: "null",
    season: "1",
    craftAmount: "null",
    turnsActive: "Instant",
    bgColor2: "#5c5f60",
    max: "7",
    areaAffected: ["Defense"],
    price: "",
    finite: "FALSE",
    description: "Jet-black bracers that absorb incoming force.",
    effect: "Increases Defense by 2",
  },
  {
    id: "CMigdt1VIX3kygZeea0H",
    name: "Aura Renewal",
    price: "",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FAura%20of%20Renewal.png?alt=media&token=702dd7c2-7213-4a0a-8a64-3eda5cc89d33",
    finite: "FALSE",
    description: "An infusion that radiates a gentle healing aura over time.",
    availForPurchase: false,
    season: "1",
    craftNeeded: "null",
    turnsActive: "2 turns",
    craftAmount: "null",
    areaAffected: ["Health"],
    max: "7",
    bgColor2: "#0089ed",
    effect: "Restores 1 health per turn for 2 turns (total 2 health).",
    bgColor1: "#83e5f8",
  },
  {
    id: "Dgp9LCQ1LsCFHSwMvD9m",
    bgColor1: "#5c512a",
    price: "",
    areaAffected: ["Defense"],
    max: "3",
    craftNeeded: "null",
    finite: "FALSE",
    name: "Stoneflesh Serum",
    description: "A rare serum that momentarily grants the strength of stone.",
    craftAmount: "null",
    turnsActive: "Instant",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FStoneflesh%20Serum.png?alt=media&token=5786b743-1bfb-4c0a-8e3c-6e53105d9e76",
    bgColor2: "#b7ab84",
    season: "1",
    effect: "Increases Defense by 3",
    availForPurchase: false,
  },
  {
    id: "Dh8CVd1QbaNMQ9xJLdE0",
    finite: "FALSE",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FWarrior%E2%80%99s%20Totem.png?alt=media&token=54da9b60-e8b6-4087-bc41-e25ee5074d6e",
    season: "1",
    availForPurchase: false,
    turnsActive: "Instant",
    price: "",
    bgColor2: "#c8781b",
    max: "10",
    craftAmount: "null",
    craftNeeded: "null",
    effect: "Increases Attack by 1",
    areaAffected: ["Attack"],
    name: "Warrior’s Totem",
    description: "A charm passed down through generations of warriors.",
    bgColor1: "#ffc531",
  },
  {
    id: "E3V9pe7yNhajAK1nhQJ2",
    bgColor2: "#1fb9fc",
    areaAffected: ["Defense"],
    effect: "Increases Defense by 1",
    price: "",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FGuardian's%20Draught.png?alt=media&token=bdd6379b-1edf-424b-970e-c7663a50e4f3",
    availForPurchase: false,
    finite: "FALSE",
    bgColor1: "#005a9e",
    craftNeeded: "null",
    season: "1",
    name: "Guardian's Draught",
    max: "10",
    craftAmount: "null",
    turnsActive: "Instant",
    description: "A battle potion favored by ancient defenders.",
  },
  {
    id: "E7nXezn5F6SuVJYOoYPE",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FVenom-tipped%20Blade.png?alt=media&token=787f8d29-4395-4432-b5f4-d5e297c971ee",
    max: "7",
    craftNeeded: "null",
    areaAffected: ["Attack"],
    turnsActive: "Instant",
    effect: "Increases Attack by 2",
    price: "",
    finite: "FALSE",
    craftAmount: "null",
    availForPurchase: false,
    season: "1",
    bgColor2: "#cff346",
    bgColor1: "#37881c",
    description: "A poisoned blade that enhances aggression and cruelty.",
    name: "Venom-tipped Blade",
  },
  {
    id: "FGqPUYRjX8tBlJbSNiEN",
    name: "Net of Binding",
    price: "",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FNet%20of%20Binding.png?alt=media&token=43dba76e-6625-4831-b808-c74c76a3d71d",
    description: "A magical net that restricts all movement temporarily.",
    finite: "FALSE",
    availForPurchase: false,
    season: "1",
    craftNeeded: "null",
    turnsActive: "Instant",
    craftAmount: "null",
    areaAffected: ["Turn Loss"],
    max: "5",
    bgColor2: "#945100",
    effect: "Target loses 2 turns",
    bgColor1: "#ffebc2",
  },
  {
    id: "FeK8jni8AQnyEGcfpaNB",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FTitanhide%20Layering.png?alt=media&token=c8578f47-98a7-4e19-b9d4-a69b12830ac3",
    finite: "TRUE",
    season: "1",
    availForPurchase: false,
    turnsActive: "Instant",
    max: "2",
    price: "",
    bgColor2: "#e18447",
    craftAmount: "2",
    craftNeeded: "Titanroot Tonic",
    effect: "Increases Defense by 3",
    name: "Titanhide Layering",
    areaAffected: ["Defense"],
    bgColor1: "#ffe860",
    description: "A layered armor upgrade formed from Titanroot Tonics.",
  },
  {
    id: "Fki1kjjWd2nYbaC5sXww",
    bgColor2: "#8d390a",
    bgColor1: "#df6f1b",
    craftNeeded: "null",
    price: "",
    craftAmount: "null",
    availForPurchase: false,
    areaAffected: ["Attack"],
    description: "Gauntlets modeled after wild beasts, sharpened to maim.",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FFeral%20Claw%20Gauntlets.png?alt=media&token=7dff4183-c35e-4356-b1ec-816fe8e81356",
    finite: "FALSE",
    effect: "Increases Attack by 2",
    max: "7",
    turnsActive: "Instant",
    name: "Feral Claw Gauntlets",
    season: "1",
  },
  {
    id: "FlUmIk9T3kKQk0vE8Iio",
    finite: "FALSE",
    availForPurchase: false,
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FSavage%20Brew.png?alt=media&token=be5e7b4e-871d-490e-b616-a13b36e3960a",
    description: "A wild mix that heightens bloodlust and raw strength.",
    areaAffected: ["Attack"],
    name: "Savage Brew",
    season: "1",
    max: "3",
    turnsActive: "Instant",
    bgColor1: "#fb9a26",
    price: "",
    effect: "Increases Attack by 3",
    bgColor2: "#fef175",
    craftAmount: "null",
    craftNeeded: "null",
  },
  {
    id: "FnMjUN9ZgMQkfmSuV550",
    bgColor1: "#feb8f7",
    areaAffected: ["Health"],
    finite: "TRUE",
    price: "",
    turnsActive: "2 turns",
    effect: "Restores 3 health over 2 turns.",
    season: "1",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FRefined%20Rejuvenation%20Elixir.png?alt=media&token=76b72b8d-95cf-460a-b403-796acee42043",
    craftAmount: "2",
    max: "2",
    craftNeeded: "Rejuvenation Elixir",
    bgColor2: "#6548cb",
    description:
      "A meticulously refined elixir that accelerates natural healing, crafted from merged Rejuvenation Elixirs.",
    name: "Refined Rejuvenation Elixir",
    availForPurchase: false,
  },
  {
    id: "JWB2oZbpSbR00K0mVAeV",
    name: "Mystic Mender",
    areaAffected: ["Health"],
    bgColor1: "#333191",
    max: "7",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FMystic%20Mender.png?alt=media&token=8802a5e8-cc74-426a-af2e-e26014d213af",
    season: "1",
    effect: "Restores 2 health instantly.",
    turnsActive: "Instant",
    craftAmount: "null",
    price: "",
    availForPurchase: false,
    craftNeeded: "null",
    description: "A shimmering potion infused with cosmic herbs.",
    finite: "FALSE",
    bgColor2: "#ffffff",
  },
  {
    id: "KjZfUxTpvI7xGmz37uJm",
    bgColor2: "#fdaaf8",
    price: "",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FWhisperleaf%20Elixir%20Max.png?alt=media&token=0dd05cff-c2f7-4e6d-bd4f-a76d5e2fee1a",
    turnsActive: "Instant",
    effect: "Increases Accuracy by 4",
    name: "Whisperleaf Elixir Max",
    availForPurchase: false,
    season: "1",
    finite: "TRUE",
    craftNeeded: "Whisperleaf Extract",
    craftAmount: "3",
    max: "2",
    description:
      "A stronger dose of Whisperleaf Extract that enhances reaction and vision.",
    bgColor1: "#ffffff",
    areaAffected: ["Accuracy"],
  },
  {
    id: "NquvLD7GdkIi6L2L7tUd",
    craftNeeded: "null",
    turnsActive: "Instant",
    availForPurchase: false,
    bgColor2: "#ffffff",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FMinor%20Healing%20Draught.png?alt=media&token=62b307b3-ac8f-4001-9669-bdd15555bfeb",
    areaAffected: ["Health"],
    effect: "Restores 1 health instantly.",
    bgColor1: "#d02c81",
    price: "",
    max: "10",
    finite: "FALSE",
    craftAmount: "null",
    name: "Minor Healing Potion",
    season: "1",
    description: "A simple potion brewed from forest herbs.",
  },
  {
    id: "O0ox6H8rrfonzOBBVJUL",
    availForPurchase: false,
    price: "",
    effect: "Increases Attack by 1",
    name: "Thunderroot Tonic",
    craftNeeded: "null",
    finite: "FALSE",
    bgColor2: "#7b3d5e",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FThunderroot%20Tonic.png?alt=media&token=7addb241-b50d-41f0-9e3b-e91d6dda3bb0",
    bgColor1: "#e52d84",
    craftAmount: "null",
    season: "1",
    description: "A drink made from a rare root that pulses with energy.",
    max: "10",
    areaAffected: ["Attack"],
    turnsActive: "Instant",
  },
  {
    id: "O4yQTGdOjA1s6hnI1P4d",
    bgColor1: "#70e236",
    finite: "FALSE",
    craftAmount: "null",
    description: "A clear brew refined to enhance spatial awareness.",
    name: "Sharpened Lens Tonic",
    turnsActive: "Instant",
    availForPurchase: false,
    season: "1",
    craftNeeded: "null",
    areaAffected: ["Accuracy"],
    bgColor2: "#beee95",
    price: "",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FSharpened%20Lens%20Tonic.png?alt=media&token=2f33c3ab-7a3a-4029-8410-70802e7dc5bd",
    max: "10",
    effect: "Increases Accuracy by 1",
  },
  {
    id: "P1k8QiKou3CRqbsgchMK",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FWhisperleaf%20Extract.png?alt=media&token=7ffa53ac-f5b5-44da-9d1a-8345f0ca558d",
    availForPurchase: false,
    effect: "Increases Accuracy by 2",
    finite: "FALSE",
    name: "Whisperleaf Extract",
    season: "1",
    craftAmount: "null",
    description: "A rare extract known to improve balance and focus.",
    price: "",
    turnsActive: "Instant",
    craftNeeded: "null",
    max: "7",
    bgColor1: "#ffffff",
    bgColor2: "#dd5fd9",
    areaAffected: ["Accuracy"],
  },
  {
    id: "PpWWvCe2rroN0KueMjkN",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FRejuvenation%20Elixir.png?alt=media&token=862acc03-2796-4a94-9132-3e4ecec13a66",
    craftAmount: "null",
    bgColor2: "#d062e7",
    availForPurchase: false,
    areaAffected: ["Health"],
    bgColor1: "#46287b",
    finite: "FALSE",
    effect: "Restores 1 health per turn for 2 turns (total 2 health).",
    name: "Rejuvenation Elixir",
    price: "",
    description: "An elixir famed for its restorative power in dire times.",
    max: "7",
    turnsActive: "2 turns",
    season: "1",
    craftNeeded: "null",
  },
  {
    id: "PwqLBRV9fGIYG5gGOId8",
    craftNeeded: "null",
    description: "A rare concoction igniting the spark of life within.",
    craftAmount: "null",
    availForPurchase: false,
    effect: "Restores 1 health per turn for 3 turns (total 3 health).",
    turnsActive: "3 turns",
    bgColor2: "#f1a428",
    max: "3",
    bgColor1: "#ffffff",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FElixer%20of%20Vital%20Spark.png?alt=media&token=fd738340-752c-496d-90d4-1d3b49597737",
    season: "1",
    areaAffected: ["Health"],
    price: "",
    name: "Vital Spark Elixir",
    finite: "FALSE",
  },
  {
    id: "QbbQAhH9rT9zTRKpgvAj",
    craftNeeded: "Minor Healing Potion",
    finite: "TRUE",
    bgColor2: "#fb79bc",
    effect: "Restores 2 health instantly.",
    name: "Greater Healing Potion",
    bgColor1: "#ee308c",
    craftAmount: "2",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FGreater%20Healing%20Draught.png?alt=media&token=5f4253ec-45b2-4f22-88a3-43f9e425164d",
    max: "5",
    turnsActive: "Instant",
    availForPurchase: false,
    areaAffected: ["Health"],
    season: "1",
    price: "",
    description:
      "A refined potion created by merging multiple Minor Healing Potions, offering a stronger restorative burst.",
  },
  {
    id: "R3HylH1GS1orDq3bqN5Q",
    availForPurchase: false,
    season: "1",
    max: "10",
    craftNeeded: "null",
    turnsActive: "Instant",
    effect: "Increases Attack by 1",
    description: "Iron-weighted gloves that pack a stronger punch.",
    bgColor2: "#cbbea5",
    craftAmount: "null",
    name: "Ironclaw Gloves",
    price: "",
    bgColor1: "#995c1b",
    finite: "FALSE",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FIronclaw%20Gloves.png?alt=media&token=ecf8b279-1dc3-4a4c-867a-f926bff981df",
    areaAffected: ["Attack"],
  },
  {
    id: "RcFrEDK17TOZUrm4OFLw",
    turnsActive: "Instant",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FBerserker%E2%80%99s%20Elixir.png?alt=media&token=983e9499-2474-4483-ac86-51c9f8f1cc33",
    description: "A thick red concoction that heightens fury.",
    areaAffected: ["Attack"],
    finite: "FALSE",
    price: "",
    name: "Berserker’s Elixir",
    effect: "Increases Attack by 3",
    bgColor1: "#44c02c",
    availForPurchase: false,
    bgColor2: "#04741e",
    season: "1",
    craftAmount: "null",
    max: "3",
    craftNeeded: "null",
  },
  {
    id: "SeK7gwQvqcAL4Xr8ojxd",
    bgColor1: "#f48acf",
    effect: "Restores 1 health per turn for 2 turns (total 2 health).",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FRenewal%20Nectar.png?alt=media&token=b9179fc9-fc90-4da7-9e27-84bff5f1c2d4",
    turnsActive: "2 turns",
    max: "7",
    price: "",
    season: "1",
    bgColor2: "#f6cde4",
    craftNeeded: "null",
    name: "Renewal Nectar",
    craftAmount: "null",
    finite: "FALSE",
    description: "A rare nectar that gradually replenishes vitality.",
    availForPurchase: false,
    areaAffected: ["Health"],
  },
  {
    id: "TxFnttkXkFxXdBqCe7o6",
    availForPurchase: false,
    season: "1",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FStoneheart%20Core.png?alt=media&token=f9638b3c-e14a-4383-8b44-a3dee01c7274",
    areaAffected: ["Defense"],
    bgColor2: "#178e1e",
    craftNeeded: "Stoneflesh Serum",
    bgColor1: "#7bd733",
    price: "",
    name: "Stoneheart Core",
    finite: "TRUE",
    turnsActive: "Instant",
    effect: "Increases Defense by 3",
    max: "1",
    description:
      "Crafted from multiple Stoneflesh Serums, this core grants extreme defense.",
    craftAmount: "3",
  },
  {
    id: "U17Zlli5bRbKeCjFduuD",
    bgColor1: "#ff5f19",
    max: "7",
    price: "",
    effect: "Increases Attack by 2",
    craftNeeded: "null",
    name: "Crimson Edge Shard",
    bgColor2: "#ffc89e",
    availForPurchase: false,
    finite: "FALSE",
    season: "1",
    turnsActive: "Instant",
    craftAmount: "null",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FCrimson%20Edge%20Shard.png?alt=media&token=daa769b8-fbd9-482d-bd34-5734af11b75a",
    description: "A cursed edge with a taste for blood.",
    areaAffected: ["Attack"],
  },
  {
    id: "UigxeOIqfQgUJFn7JuLk",
    description:
      "Brewed from titanroot bark, this tonic reinforces the user’s form.",
    finite: "FALSE",
    availForPurchase: false,
    effect: "Increases Defense by 2",
    max: "7",
    bgColor2: "#ffe33e",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FTitanroot%20Tonic.png?alt=media&token=08b9846f-dd02-4f0f-b39f-6761c6ddcac7",
    turnsActive: "Instant",
    season: "1",
    craftAmount: "null",
    name: "Titanroot Tonic",
    areaAffected: ["Defense"],
    bgColor1: "#efa528",
    craftNeeded: "null",
    price: "",
  },
  {
    id: "Usq1qkHXbz6hbGXTKVgO",
    season: "1",
    finite: "FALSE",
    craftNeeded: "null",
    description: "A thick potion that toughens the skin like bark.",
    areaAffected: ["Defense"],
    effect: "Increases Defense by 1",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FBarkskin%20Brew.png?alt=media&token=ff507ff9-3ade-4410-9b59-e44a2fa5e562",
    name: "Barkskin Brew",
    price: "",
    bgColor2: "#6a420a",
    availForPurchase: false,
    bgColor1: "#bb791b",
    turnsActive: "Instant",
    craftAmount: "null",
    max: "10",
  },
  {
    id: "V8AFiagDbeR8W44hweO1",
    bgColor2: "#dbedf0",
    finite: "FALSE",
    availForPurchase: false,
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FEagke%20Eye%20Elixer.png?alt=media&token=0f34ab5c-c9e3-476c-99f4-338bd3bfef37",
    name: "Eagle Eye Elixir",
    bgColor1: "#109cfb",
    description: "A bright-blue potion that sharpens vision and focus.",
    turnsActive: "Instant",
    areaAffected: ["Accuracy"],
    price: "",
    season: "1",
    effect: "Increases Accuracy by 1",
    craftAmount: "null",
    max: "10",
    craftNeeded: "null",
  },
  {
    id: "VOLkwRH0T8dW5PLA3YHZ",
    craftNeeded: "null",
    bgColor2: "#90b97e",
    bgColor1: "#1c811a",
    name: "Healing Brew",
    availForPurchase: false,
    max: "7",
    description:
      "A well-crafted brew renowned for its quick recovery properties.",
    effect: "Restores 2 health instantly.",
    areaAffected: ["Health"],
    price: "",
    season: "1",
    turnsActive: "Instant",
    finite: "FALSE",
    craftAmount: "null",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FHealing%20Brew.png?alt=media&token=6f7eab35-1ffd-4e96-a836-c5282d9ffd60",
  },
  {
    id: "WIeYO0PUf4dm4IbFF1eY",
    max: "7",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FBoneblade%20Fragment.png?alt=media&token=7f3bb748-ceff-4277-b9b8-1abc9d236594",
    finite: "FALSE",
    craftNeeded: "null",
    turnsActive: "Instant",
    bgColor2: "#a78554",
    availForPurchase: false,
    areaAffected: ["Attack"],
    price: "",
    name: "Boneblade Fragment",
    description: "A cracked sliver from a war beast’s tusk, ready to pierce.",
    craftAmount: "null",
    effect: "Increases Attack by 2",
    bgColor1: "#b59360",
    season: "1",
  },
  {
    id: "WaseiOAYJWjbtUuiJtOM",
    price: "",
    bgColor2: "#ffffff",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FLuminous%20Liquid.png?alt=media&token=9037cda4-959c-44aa-956e-86df9ea7a373",
    craftAmount: "null",
    season: "1",
    finite: "FALSE",
    name: "Luminous Liquid",
    description: "A glowing liquid that sparks the body’s natural healing.",
    turnsActive: "Instant",
    bgColor1: "#68cfe6",
    areaAffected: ["Health"],
    availForPurchase: false,
    craftNeeded: "null",
    effect: "Restores 1 health instantly.",
    max: "10",
  },
  {
    id: "Wedhw04HPGVsHIbnYHZG",
    max: "3",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FGhoststeel%20Spike.png?alt=media&token=19ac5e06-9ee8-4f21-b3e8-e479852ca149",
    price: "",
    craftAmount: "null",
    season: "1",
    finite: "FALSE",
    name: "Ghoststeel Spike",
    bgColor1: "#7ffafe",
    description: "A small throwing spike forged in spectral flame.",
    turnsActive: "Instant",
    effect: "Increases Attack by 3",
    craftNeeded: "null",
    areaAffected: ["Attack"],
    availForPurchase: false,
    bgColor2: "#036d9d",
  },
  {
    id: "WmtTSdOh3AnhCUuFR7Hp",
    craftNeeded: "null",
    season: "1",
    description:
      "A slick liquid that hardens on contact, forming a temporary shell.",
    turnsActive: "Instant",
    craftAmount: "null",
    availForPurchase: false,
    bgColor1: "#ed3c98",
    areaAffected: ["Defense"],
    max: "7",
    bgColor2: "#febade",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FShell%20Oil.png?alt=media&token=279df12b-e34f-4292-ad31-faaf1b875eec",
    finite: "FALSE",
    name: "Shell Oil",
    effect: "Increases Defense by 2",
    price: "",
  },
  {
    id: "Zaq3fRKNhPALXKYqDNgm",
    bgColor1: "#ffffff",
    availForPurchase: false,
    max: "10",
    craftAmount: "null",
    effect: "Increases Accuracy by 1",
    name: "Frostglint Liquid",
    turnsActive: "Instant",
    bgColor2: "#0edbfd",
    finite: "FALSE",
    areaAffected: ["Accuracy"],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FFrostglint%20Liquid.png?alt=media&token=b624bad1-5cbc-435a-9e2f-b9636c12e56b",
    description: "A chilled potion that clears the mind and eye.",
    price: "",
    craftNeeded: "null",
    season: "1",
  },
  {
    id: "aEwRtIlOtkew6cKGBwhn",
    craftAmount: "3",
    description:
      "An evolved version of Moonlight Scope, crafted for elite marksmen.",
    areaAffected: ["Accuracy"],
    bgColor1: "#ccdfe5",
    availForPurchase: false,
    effect: "Increases Accuracy by 4",
    turnsActive: "Instant",
    name: "Scope of the Silver Eye",
    finite: "TRUE",
    season: "1",
    bgColor2: "#3288c1",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FScope%20of%20the%20Silver%20Eye.png?alt=media&token=5ca58ab1-455f-4c10-b000-5bf647422216",
    max: "2",
    price: "",
    craftNeeded: "Moonlight Scope",
  },
  {
    id: "aqzMC2rHVkO0u4EfcdMl",
    max: "7",
    bgColor1: "#1e97df",
    areaAffected: ["Defense"],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FEthersteel%20Wraps.png?alt=media&token=5b5a8dd8-bc62-4eab-ba6e-ef8b90b500b9",
    craftAmount: "null",
    availForPurchase: false,
    price: "",
    name: "Ethersteel Wraps",
    effect: "Increases Defense by 2",
    season: "1",
    bgColor2: "#ffffff",
    turnsActive: "Instant",
    finite: "FALSE",
    craftNeeded: "null",
    description: "Bands of flexible, magical alloy that resist blows.",
  },
  {
    id: "bnySrxduySbFQmSdyRHs",
    craftNeeded: "Warrior’s Totem",
    availForPurchase: false,
    turnsActive: "Instant",
    name: "Totem of the Ravager",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FTotem%20of%20the%20Ravager.png?alt=media&token=f119a259-a006-4636-a6d6-946e82dd84e6",
    finite: "TRUE",
    bgColor2: "#ec3e13",
    bgColor1: "#ff9380",
    season: "1",
    max: "1",
    areaAffected: ["Attack"],
    price: "",
    description:
      "A fused relic of savage tribes, overflowing with brutal spirit.",
    craftAmount: "3",
    effect: "Increases Attack by 5",
  },
  {
    id: "c4QXYVwD7DpxRPt3U14Z",
    effect: "Increases Attack by 1",
    turnsActive: "Instant",
    finite: "FALSE",
    season: "1",
    bgColor2: "#ad742c",
    craftNeeded: "null",
    availForPurchase: false,
    price: "",
    description: "An ancient bone-crafted ring used by tribal berserkers.",
    bgColor1: "#f4cc85",
    max: "10",
    areaAffected: ["Attack"],
    craftAmount: "null",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FBoneknuckle%20Ring.png?alt=media&token=a36d16de-b3f9-4eeb-910c-0ed1fde7667b",
    name: "Boneknuckle Ring",
  },
  {
    id: "ca2HjhNsqGBe84PU1OpH",
    bgColor2: "#6658d0",
    finite: "FALSE",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FMoonlight%20Scope.png?alt=media&token=c751b025-eaa2-4dfa-a2f3-180737411d62",
    price: "",
    name: "Moonlight Scope",
    availForPurchase: false,
    turnsActive: "Instant",
    season: "1",
    bgColor1: "#ffffff",
    areaAffected: ["Accuracy"],
    description: "A scope enchanted under moonlight, enhancing targeting.",
    max: "7",
    craftAmount: "null",
    effect: "Increases Accuracy by 2",
    craftNeeded: "null",
  },
  {
    id: "cqwCeHDc14J5DTneywEp",
    effect: "Increases Accuracy by 3",
    finite: "FALSE",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FSmoke%20Lens%20Powder.png?alt=media&token=53a566a7-586f-4aa4-8ee4-a9df7a208724",
    price: "",
    turnsActive: "Instant",
    season: "1",
    name: "Smoke Lens Powder",
    availForPurchase: false,
    craftAmount: "null",
    max: "3",
    craftNeeded: "null",
    areaAffected: ["Accuracy"],
    bgColor2: "#ffffff",
    bgColor1: "#735f40",
    description:
      "A powdered lens filter that cuts through battlefield distractions.",
  },
  {
    id: "dwLFJBtGQmwWgMNhiXA3",
    bgColor2: "#ff701c",
    finite: "TRUE",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FBlazing%20Fang%20Blade.png?alt=media&token=d8f853c7-9ea3-458a-8f0f-55e59ebad1e1",
    price: "",
    name: "Blazing Fang Blade",
    turnsActive: "Instant",
    availForPurchase: false,
    season: "1",
    bgColor1: "#ffdd58",
    areaAffected: ["Attack"],
    description:
      "Forged by merging Emberfang Blades, it burns with devastating fury.",
    max: "2",
    craftAmount: "3",
    craftNeeded: "Emberfang Blade",
    effect: "Increases Attack by 4",
  },
  {
    id: "e1Nrxlq3WzM74ce0flMB",
    finite: "FALSE",
    price: "",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FTrickshot%20Tonic.png?alt=media&token=3baf1be4-0db6-4570-8bb0-86b3888c5d3c",
    description: "A flashy brew favored by confident marksmen.",
    effect: "Increases Accuracy by 3",
    season: "1",
    craftNeeded: "null",
    bgColor1: "#fee138",
    craftAmount: "null",
    max: "3",
    name: "Trickshot Tonic",
    areaAffected: ["Accuracy"],
    bgColor2: "#fdc130",
    availForPurchase: false,
    turnsActive: "Instant",
  },
  {
    id: "f49dJbLmkrsdsldrjzhk",
    bgColor1: "#1ab8fb",
    max: "7",
    name: "Paralysis Powder",
    areaAffected: ["Turn Loss"],
    craftAmount: "null",
    availForPurchase: false,
    effect: "Target loses 1 turn",
    bgColor2: "#00224b",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FParalysis%20Powder.png?alt=media&token=9c1a8872-e33a-4a2c-953e-f4dc31be59e5",
    price: "",
    season: "1",
    description: "A fine dust that causes instant muscle lock.",
    craftNeeded: "null",
    finite: "FALSE",
    turnsActive: "Instant",
  },
  {
    id: "fBrH8ZJ1swjxmkHKpe2B",
    price: "",
    effect: "Increases Accuracy by 1",
    description: "A gem said to improve one's perception of motion.",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FMystic%20Eyestone.png?alt=media&token=784585d1-e9ad-4130-82b3-3c3a14b4e947",
    availForPurchase: false,
    name: "Mystic Eyestone",
    turnsActive: "Instant",
    bgColor1: "#c8fcff",
    finite: "FALSE",
    areaAffected: ["Accuracy"],
    max: "10",
    season: "1",
    craftAmount: "null",
    craftNeeded: "null",
    bgColor2: "#335880",
  },
  {
    id: "fN1gokIekIRRelHuuqRn",
    finite: "FALSE",
    bgColor2: "#f4e867",
    availForPurchase: false,
    bgColor1: "#ffffff",
    turnsActive: "Instant",
    max: "10",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FGlimmerdust%20Vial.png?alt=media&token=2c5fd3a6-b77f-459d-a04f-e5c315e1ba45",
    craftNeeded: "null",
    name: "Glimmerdust Vial",
    price: "",
    effect: "Increases Accuracy by 1",
    season: "1",
    description:
      "Sparkling dust that improves eye-hand coordination when inhaled.",
    craftAmount: "null",
    areaAffected: ["Accuracy"],
  },
  {
    id: "gdXi1ENZf0kup5Aeh1uW",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FPitfall%20Token.png?alt=media&token=a2ef0808-84ec-42de-810d-0abc6e1e73f9",
    max: "5",
    price: "",
    finite: "FALSE",
    description: "A deceptive terrain token that opens a hidden pit.",
    name: "Pitfall Token",
    season: "1",
    craftNeeded: "null",
    craftAmount: "null",
    bgColor1: "#fde146",
    areaAffected: ["Turn Loss"],
    bgColor2: "#c4760d",
    turnsActive: "Instant",
    effect: "Target loses 2 turns",
    availForPurchase: false,
  },
  {
    id: "i8CPqBsevRjtOdhfjzkb",
    craftAmount: "null",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FDivine%20Drop.png?alt=media&token=60dcfb30-3f87-4e5a-85e3-4e1bbc0d093d",
    bgColor2: "#ffb4a3",
    finite: "FALSE",
    price: "",
    areaAffected: ["Health"],
    name: "Divine Drop",
    max: "7",
    craftNeeded: "null",
    availForPurchase: false,
    season: "1",
    description: "A drop of divine essence that briefly bestows vitality.",
    effect: "Restores 2 health instantly.",
    turnsActive: "Instant",
    bgColor1: "#c3101b",
  },
  {
    id: "iA0VeHV3HuvHtnrtZZGO",
    availForPurchase: false,
    areaAffected: ["Health"],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FMajestic%20Lifebloom%20Potion.png?alt=media&token=ab391742-fb9e-43f2-989b-4e5f1a6c8853",
    max: "1",
    name: "Majestic Lifebloom Potion",
    season: "1",
    craftAmount: "3",
    craftNeeded: "Lifebloom Potion",
    finite: "TRUE",
    effect:
      "Restores 3 health instantly plus an additional 1 health after 1 turn (total 4 health).",
    bgColor1: "#ffe356",
    description:
      "An enhanced version of the Lifebloom Potion, merged to produce a majestic healing effect.",
    bgColor2: "#ff9f28",
    turnsActive: "Instant + 1 turn",
    price: "",
  },
  {
    id: "jdly8VShytJCnWzbsYgg",
    price: "",
    effect: "Increases Attack by 2",
    bgColor2: "#e87d59",
    turnsActive: "Instant",
    craftNeeded: "null",
    craftAmount: "null",
    finite: "FALSE",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FEmberfang%20Blade.png?alt=media&token=076e1799-3a7e-473a-9204-48f6bff71e51",
    areaAffected: ["Attack"],
    description: "A fiery fang repurposed as a lethal dagger.",
    availForPurchase: false,
    season: "1",
    name: "Emberfang Blade",
    max: "7",
    bgColor1: "#fe631a",
  },
  {
    id: "lpbRbhkp23UlieMvpo5n",
    availForPurchase: false,
    areaAffected: ["Attack"],
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FGhoststeel%20Shuriken.png?alt=media&token=1d4b39d8-722d-4714-81e8-7f42d8a188cb",
    max: "2",
    name: "Ghoststeel Shuriken",
    season: "1",
    craftAmount: "2",
    craftNeeded: "Ghoststeel Spike",
    finite: "TRUE",
    effect: "Increases Attack by 4",
    bgColor1: "#aa74f5",
    description:
      "An evolved form of the Ghoststeel Spike, forged for lethal precision.",
    bgColor2: "#a694ff",
    turnsActive: "Instant",
    price: "",
  },
  {
    id: "mlqpKvmU4Aax3fJIw9lj",
    name: "Crystal Armor Shard",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FCrystal%20Armor%20Shard.png?alt=media&token=9b94f67b-b655-4abb-a07f-4ec54ce8ae0b",
    price: "",
    effect: "Increases Defense by 1",
    description: "A fragment of enchanted armor infused with defensive magic.",
    max: "10",
    areaAffected: ["Defense"],
    turnsActive: "Instant",
    availForPurchase: false,
    bgColor2: "#07436a",
    craftNeeded: "null",
    finite: "FALSE",
    craftAmount: "null",
    season: "1",
    bgColor1: "#79f2fa",
  },
  {
    id: "mlzHNFYdqXbjOcz5qcLm",
    availForPurchase: false,
    description: "A small blade wreathed in residual fire energy.",
    name: "Flamebrand Dagger",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FFlamebrand%20Dagger.png?alt=media&token=85207f74-9b23-4d9f-865e-7e9761e5b88f",
    areaAffected: ["Attack"],
    max: "10",
    craftAmount: "null",
    bgColor1: "#ff8b23",
    season: "1",
    price: "",
    craftNeeded: "null",
    turnsActive: "Instant",
    bgColor2: "#ffc230",
    finite: "FALSE",
    effect: "Increases Attack by 1",
  },
  {
    id: "oTUsFVAH0QElfL0bkO6B",
    finite: "FALSE",
    craftNeeded: "null",
    max: "10",
    areaAffected: ["Health"],
    effect: "Restores 1 health instantly.",
    description: "A tiny vial of rejuvenating liquid for minor wounds.",
    availForPurchase: false,
    turnsActive: "Instant",
    craftAmount: "null",
    bgColor1: "#4aad27",
    name: "Tiny Elixir",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FTinyElixer.png?alt=media&token=0ccc4a29-9b08-4d26-a58b-9eaa753ead4e",
    season: "1",
    bgColor2: "#ffffff",
    price: "",
  },
  {
    id: "qlFuLpIZXHMH42Y6XnXB",
    price: "",
    finite: "FALSE",
    areaAffected: ["Accuracy"],
    bgColor2: "#d0e8f0",
    craftAmount: "null",
    season: "1",
    effect: "Increases Accuracy by 2",
    availForPurchase: false,
    name: "Steadyhand Brew",
    description: "A calming draught that stills the nerves and improves aim.",
    max: "7",
    turnsActive: "Instant",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FSteadyhand%20Brew.png?alt=media&token=8f70c2d0-f949-4c74-a6be-9d1090639431",
    bgColor1: "#2971a2",
    craftNeeded: "null",
  },
  {
    id: "qpkUCqD3tvzUnJLCt0VE",
    price: "",
    effect: "Increases Attack by 2",
    bgColor2: "#045715",
    turnsActive: "Instant",
    craftNeeded: "null",
    finite: "FALSE",
    craftAmount: "null",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FRazorleaf%20Shard.png?alt=media&token=9a192845-f83f-48c0-8262-616d3ac4989f",
    areaAffected: ["Attack"],
    description:
      "A jagged fragment of a legendary blade that sharpens the senses.",
    availForPurchase: false,
    season: "1",
    name: "Razorleaf Shard",
    max: "7",
    bgColor1: "#cded4f",
  },
  {
    id: "s1DUFkzAmtFJITVBJlwf",
    bgColor1: "#fdae2b",
    areaAffected: ["Health"],
    max: "3",
    bgColor2: "#ffffff",
    effect: "Restores 3 health instantly.",
    price: "",
    finite: "FALSE",
    season: "1",
    availForPurchase: false,
    name: "Lifebloom Potion",
    craftNeeded: "null",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FLifebloom%20Potion.png?alt=media&token=6cb9b1e8-1420-421b-b904-7652c06cea21",
    description:
      "A vibrant potion made from the petals of the mythical lifebloom.",
    turnsActive: "Instant",
    craftAmount: "null",
  },
  {
    id: "tX3LSI5VKajBx0v8wokW",
    max: "7",
    bgColor2: "#ffffff",
    craftAmount: "null",
    bgColor1: "#b45713",
    turnsActive: "Instant",
    availForPurchase: false,
    price: "",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FArcher's%20Charm.png?alt=media&token=49320f06-afd5-4e1c-9cb1-00b05fd3dd5e",
    craftNeeded: "null",
    description: "A lucky charm passed down by legendary archers.",
    finite: "FALSE",
    effect: "Increases Accuracy by 2",
    season: "1",
    name: "Archer's Charm",
    areaAffected: ["Accuracy"],
  },
  {
    id: "tbkfNf4N2ZUKZ0o7IJbv",
    turnsActive: "Instant",
    effect: "Target loses 1 turn",
    finite: "FALSE",
    craftAmount: "null",
    areaAffected: ["Turn Loss"],
    season: "1",
    name: "Snare Trap",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FSnare%20Trap.png?alt=media&token=3cca2334-b4d8-457c-b528-96b704e7e1c9",
    price: "",
    availForPurchase: false,
    craftNeeded: "null",
    description: "A hidden rope trap that immobilizes the opponent.",
    max: "7",
    bgColor2: "#311801",
    bgColor1: "#895316",
  },
  {
    id: "ug999ZOONr7pIIOr6cxH",
    description: "A polished artifact made from fused Sightstone Fragments.",
    max: "2",
    craftNeeded: "Sightstone Fragment",
    availForPurchase: false,
    turnsActive: "Instant",
    name: "Seer’s Lens",
    bgColor2: "#0aafe6",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FSeer%E2%80%99s%20Lens.png?alt=media&token=90b78d30-014e-4dd5-b0b6-161dfb18ac1b",
    finite: "TRUE",
    craftAmount: "3",
    season: "1",
    areaAffected: ["Accuracy"],
    bgColor1: "#ffffff",
    price: "",
    effect: "Increases Accuracy by 4",
  },
  {
    id: "vz8A1LlDNldnwqYRQPVk",
    max: "10",
    effect: "Increases Defense by 1",
    name: "Emberhide Inlay",
    season: "1",
    bgColor2: "#701300",
    areaAffected: ["Defense"],
    bgColor1: "#c62d0c",
    price: "",
    craftAmount: "null",
    description:
      "Armor lining crafted from fire-resistant hide, instantly boosting defense.",
    craftNeeded: "null",
    availForPurchase: false,
    turnsActive: "Instant",
    finite: "FALSE",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FEmberhide%20Inlay.png?alt=media&token=df71ff64-cf48-4b52-9a0e-5c1bb2c70383",
  },
  {
    id: "xfOIfM6UkFYcA2KgFpEs",
    season: "1",
    bgColor2: "#d9d9d9",
    price: "",
    description: "Heavy gauntlets that harden the user’s stance in battle.",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FIronhide%20Gauntlets.png?alt=media&token=01e0ed6e-7e81-4032-a6bc-1ebf6953ab2b",
    turnsActive: "Instant",
    craftAmount: "null",
    areaAffected: ["Defense"],
    effect: "Increases Defense by 1",
    craftNeeded: "null",
    max: "10",
    finite: "FALSE",
    name: "Ironhide Gauntlets",
    bgColor1: "#6c7075",
    availForPurchase: false,
  },
  {
    id: "ykE9uQqBgRB2aT7Qhbdn",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FEnhanced%20Vitality%20Via.png?alt=media&token=284ddc6d-a393-4791-85c8-a53cdb89d224",
    bgColor2: "#fea729",
    name: "Enhanced Vitality Vial",
    price: "",
    turnsActive: "3 turns",
    max: "2",
    bgColor1: "#ed4913",
    season: "1",
    craftAmount: "3",
    availForPurchase: false,
    areaAffected: ["Health"],
    description:
      "An intensified essence of life crafted from merging Vitality Vials, delivering a potent surge of healing.",
    finite: "TRUE",
    effect: "Restores 4 health over 3 turns.",
    craftNeeded: "Vitality Vial",
  },
  {
    id: "zLZ7TJphndSOaOC5n3xK",
    season: "1",
    craftAmount: "null",
    effect: "Increases Accuracy by 2",
    price: "",
    turnsActive: "Instant",
    areaAffected: ["Accuracy"],
    name: "Sightstone Fragment",
    bgColor1: "#c7fdf3",
    imageUrl:
      "https://firebasestorage.googleapis.com/v0/b/infinft-card-game.firebasestorage.app/o/Infinity%20Card%20Images%2FSightstone%20Fragment.png?alt=media&token=7bd66949-0bad-4b2d-8de0-b2f888ec2c4d",
    craftNeeded: "null",
    description:
      "A magical fragment from a seeing stone used by ancient seers.",
    finite: "FALSE",
    availForPurchase: false,
    max: "7",
    bgColor2: "#23e3da",
  },
];
